module.exports = __webpack_public_path__ + "static/images/daji.d174b80.png";